import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';
import { EMPTY_VALUE } from '../../constants/empty-value';

/**
 * Whole UTC calendar days from today until `date`, clamped at zero so a passed date reads as
 * no days left rather than a negative count. Returns {@link EMPTY_VALUE} when there is no valid
 * date. The caller supplies the unit, so the template can pick "Day" or "Days".
 */
@Pipe({ name: 'daysUntil' })
export class FormatDaysUntilPipe implements PipeTransform {
    transform(date: Date | null | undefined): number | string {
        if (date == null || isNaN(date.getTime())) {
            return EMPTY_VALUE;
        }
        const days = moment.utc(date).startOf('day').diff(moment.utc().startOf('day'), 'days');
        return Math.max(days, 0);
    }
}
